var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6083 7.15257C14.55 7.14424 14.4917 7.14424 14.4333 7.15257C13.1417 7.11091 12.1167 6.05257 12.1167 4.75257C12.1167 3.42757 13.1917 2.34424 14.525 2.34424C15.85 2.34424 16.9333 3.41924 16.9333 4.75257C16.925 6.05257 15.9 7.11091 14.6083 7.15257Z",
    fill: "#B90022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.325 12.9276C16.3917 13.5526 15.0833 13.7859 13.875 13.6276C14.1917 12.9442 14.3583 12.1859 14.3667 11.3859C14.3667 10.5526 14.1833 9.76092 13.8333 9.06925C15.0667 8.90258 16.375 9.13592 17.3167 9.76092C18.6333 10.6276 18.6333 12.0526 17.325 12.9276Z",
    fill: "#B90022"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36667 7.15257C5.425 7.14424 5.48333 7.14424 5.54167 7.15257C6.83333 7.11091 7.85833 6.05257 7.85833 4.75257C7.85833 3.41924 6.78333 2.34424 5.45 2.34424C4.125 2.34424 3.05 3.41924 3.05 4.75257C3.05 6.05257 4.075 7.11091 5.36667 7.15257Z",
    fill: "#B90022"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45833 11.3861C5.45833 12.1944 5.63333 12.9611 5.95 13.6527C4.775 13.7777 3.55 13.5277 2.65 12.9361C1.33333 12.0611 1.33333 10.6361 2.65 9.76107C3.54167 9.16107 4.8 8.91941 5.98333 9.05274C5.64166 9.75274 5.45833 10.5444 5.45833 11.3861Z",
    fill: "#B90022"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 13.9027C10.0333 13.8944 9.95833 13.8944 9.88333 13.9027C8.35 13.8527 7.125 12.5944 7.125 11.0444C7.13333 9.46107 8.40833 8.17773 10 8.17773C11.5833 8.17773 12.8667 9.46107 12.8667 11.0444C12.8583 12.5944 11.6417 13.8527 10.1 13.9027Z",
    fill: "#B90022"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39167 15.6279C6.13333 16.4696 6.13333 17.8529 7.39167 18.6863C8.825 19.6446 11.175 19.6446 12.6083 18.6863C13.8667 17.8446 13.8667 16.4613 12.6083 15.6279C11.1833 14.6696 8.83333 14.6696 7.39167 15.6279Z",
    fill: "#B90022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleactive);
export default __webpack_public_path__ + "static/media/peopleactive.80a4219e7323edf8e4a20717c9a54c4b.svg";
export { ForwardRef as ReactComponent };